import { computed, observable } from 'mobx';

import { SerializedData, Store } from 'bernie-core';

import { FlightsShoppingPwaFlightSearchResultsFlightsSearch } from '__generated__/api';
import NoListingMessaging = FlightsShoppingPwaFlightSearchResultsFlightsSearch.NoListingMessaging;
import FailedRequestMessaging = FlightsShoppingPwaFlightSearchResultsFlightsSearch.FailedRequestMessaging;

export class ErrorStore extends Store {
  @observable public clientFetchFailure: boolean;
  @observable public noListingMessaging: NoListingMessaging;
  @observable public failedRequestMessaging: FailedRequestMessaging;

  @observable public noApiResponse: boolean;

  @computed get shouldRenderNFFMessage(): boolean {
    return (
      !this.clientFetchFailure &&
      this.noListingMessaging &&
      (this.noListingMessaging.__typename === 'FlightsNoFlightsFoundMessaging' ||
        this.noListingMessaging.__typename === 'FlightsNoFlightsFoundWithFilterMessaging')
    );
  }

  @computed get shouldRenderFailedRequestError(): boolean {
    return (
      (this.clientFetchFailure || this.noListingMessaging) &&
      this.failedRequestMessaging &&
      !this.shouldRenderNFFMessage
    );
  }

  @computed get shouldRenderNoApiResponseError(): boolean {
    return (
      !this.shouldRenderFailedRequestError &&
      !this.shouldRenderNFFMessage &&
      (this.noApiResponse || this.clientFetchFailure)
    );
  }

  public hydrate(data: SerializedData): void {
    Object.assign(this, data);
  }
}

ErrorStore.DEFAULTS = {
  clientFetchFailure: false,
  noListingMessaging: null,
  failedRequestMessaging: null,
  noApiResponse: true
};
